import HardwareSerializer from 'eflex/serializers/hardware';

export default class TurckIoSerializer extends HardwareSerializer {}
